import React from 'react'
import GenericModal from '../generic-modal/generic-modal'
import Button from '../../atoms/button/button'
import { useModal } from '../../../hooks/useModal'
import './error-modal.scss'

const ErrorModal = ({
	title = '¡Ups! Algo salió mal',
	description = 'Parece que hubo un problema al procesar tu solicitud.\nPor favor, inténtalo de nuevo más tarde',
	buttonText = 'Aceptar',
	onButtonClick,
}) => {
	const { showModal } = useModal()
	return (
		<GenericModal className='modal--large f-error-modal'>
			<div className='f-modal-info'>
				<div className='f-main-title-container'>
					<label className='f-main-title'>{title}</label>
				</div>
				<div className='f-description-container'>
					<p className='f-description'>
						{description.split('\n').map((line, index) => (
							<React.Fragment key={index}>
								{line}
								{index < description.split('\n').length - 1 && <br />}
							</React.Fragment>
						))}
					</p>
				</div>

				<div className='f-btn-container'>
					<div className='f-btn-interaction-container'>
						<Button
							title={buttonText}
							className='new-dark-blue'
							onClick={onButtonClick || (() => showModal(null))}
						/>
					</div>
				</div>
			</div>
		</GenericModal>
	)
}

export default ErrorModal
